<pr-page-splash>
  <pt-multifactor-verify-page />
</pr-page-splash>
